import { Delete, CheckRounded, Publish } from "@mui/icons-material";

import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DialogBox from "../dialogBox/DialogBox";
import { appConfig } from "../../config/appConfig";
import { decode } from "../../utils/helper";
import { getStorageItemLocal } from "../../services/storageServices";
interface Props {
  refresh: boolean;
}

const Unpprovevideo: React.FC<Props> = ({ refresh }) => {
  const [dataList, setDataList] = useState<any[]>([]);
  const [unapprove, setUnapprove] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [publishDialog, setPublishDialog] = useState(false);
  const fetchLatestVideo = async () => {
    try {
      const response = await fetch(appConfig.serviceUrls.getIntroductoryVideo);

      if (!response.ok) {
        throw new Error("Failed to fetch latest video");
      }

      const data = await response.json();
      setDataList([data]);
    } catch (err) {
      console.error("Error fetching latest video:", err);
    }
  };
  useEffect(() => {
    fetchLatestVideo();
  }, [refresh]);

  const handleapprove = (index: any) => {
    setSelectedRow(index);
    setUnapprove(true);
  };

  const onDialogSubmitapprove = async () => {
    const username = getStorageItemLocal("username") ?? "";

    const formData = new FormData();
    formData.append("UploadBy", username || "");
    formData.append("Status", "approve");
    formData.append("Publish", "false");

    try {
      const response = await fetch(
        `${appConfig.serviceUrls.updateIntroductoryVideo}/${selectedRow}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update video entry");
      }

      const result = await response.json();
      alert("Update successful!");

      fetchLatestVideo();
    } catch (error) {
      alert("Network Error");
      console.error("Error updating video entry:", error);
    } finally {
      setUnapprove(false);
    }
  };

  const handledelete = (index: any) => {
    setSelectedRow(index);
    setDeleteDialog(true);
  };

  const onDialogSubmitDelete = async () => {
    try {
      const response = await fetch(
        `${appConfig.serviceUrls.deleteIntroductoryVideo}/${selectedRow}`,
        {
          method: "DELETE",
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch video data");
      }
      alert("Data deleted successfull");
      fetchLatestVideo();
    } catch (err: any) {
      console.error("Error fetching video by ID:", err);
      alert("Network Error");
    } finally {
      setDeleteDialog(false);
    }
  };

  const handlepublish = (index: any) => {
    setSelectedRow(index);
    setPublishDialog(true);
  };
  const onDialogSubmitPublish = async () => {
    const username = getStorageItemLocal("username") ?? "";

    const formData = new FormData();
    formData.append("UploadBy", username || "");
    formData.append("Status", "approve");
    formData.append("Publish", "true");

    try {
      const response = await fetch(
        `${appConfig.serviceUrls.updateIntroductoryVideo}/${selectedRow}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update video entry");
      }

      alert("Update successful!");

      fetchLatestVideo();
    } catch (error) {
      alert("Network Error");
      console.error("Error updating video entry:", error);
    } finally {
      setPublishDialog(false);
    }
  };

  const hasApprovedItems = dataList.some((item) => item.status === "approve");
  // eslint-disable-next-line eqeqeq
  const hasUnpublishedItems = dataList.some((item) => item.publish == false);

  return (
    <Box>
      {dataList?.length > 0 && hasUnpublishedItems ? (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Introductory video</b>
              </TableCell>
              <TableCell>
                <b>Uploaded BY</b>
              </TableCell>
              <TableCell>
                <b>Uploaded Time</b>
              </TableCell>
              <TableCell>
                <b>Status</b>
              </TableCell>

              <TableCell>
                <b>Actions</b>
              </TableCell>

              {hasApprovedItems && (
                <TableCell>
                  <b>Publish</b>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataList?.map((item: any, index: any) => (
              <TableRow key={index}>
                <TableCell>
                  {typeof item.videoUrls === "string" ? (
                    item.videoUrls.split(",").map((vid: any, index: any) => (
                      <div key={index}>
                        <a
                          href={`https://localhost:44354${vid.trim()}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {vid}
                        </a>
                      </div>
                    ))
                  ) : (
                    <Typography>No videoUrls</Typography>
                  )}
                </TableCell>
                <TableCell>{item?.uploadBy || "\u00A0"}</TableCell>
                <TableCell>{item?.uploadTime || "\u00A0"}</TableCell>
                <TableCell>{item?.status || "\u00A0"}</TableCell>
                <TableCell align="center">
                  {!hasApprovedItems && (
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() => {
                        handleapprove(item?.id);
                      }}
                    >
                      <CheckRounded fontSize="small" />
                    </IconButton>
                  )}

                  <IconButton
                    onClick={() => {
                      handledelete(item?.id);
                    }}
                    color="error"
                    size="small"
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
                {hasApprovedItems && (
                  <TableCell>
                    {item.status === "approve" ? (
                      <IconButton
                        size="small"
                        onClick={() => {
                          handlepublish(item?.id);
                        }}
                      >
                        <Publish color="primary" fontSize="small" />
                      </IconButton>
                    ) : (
                      ""
                    )}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Box> </Box>
      )}

      <DialogBox
        isOpen={unapprove}
        title="Do you want to approve the Introductory video"
        buttons={[
          {
            text: "CANCEL",
            onPressed: () => setUnapprove(false),
            variant: "outlined",
          },
          {
            text: "APPROVE",
            onPressed: onDialogSubmitapprove,
            variant: "contained",
          },
        ]}
        onClose={() => setUnapprove(false)}
      />

      <DialogBox
        isOpen={deleteDialog}
        title="Do you want to Delete the Introductory video"
        buttons={[
          {
            text: "CANCEL",
            onPressed: () => setDeleteDialog(false),
            variant: "outlined",
          },
          {
            text: "DELETE",
            onPressed: onDialogSubmitDelete,
            variant: "contained",
          },
        ]}
        onClose={() => setDeleteDialog(false)}
      />
      <DialogBox
        isOpen={publishDialog}
        title="Do you want to Publish the Introductory video"
        buttons={[
          {
            text: "CANCEL",
            onPressed: () => setPublishDialog(false),
            variant: "outlined",
          },
          {
            text: "Publish",
            onPressed: onDialogSubmitPublish,
            variant: "contained",
          },
        ]}
        onClose={() => setPublishDialog(false)}
      />
    </Box>
  );
};

export default Unpprovevideo;
